import { Draggable } from "@hello-pangea/dnd";
import { DragHandle } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import { ComponentType } from "react";

type WithDraggableProps<T> = T & {
  draggableId: string;
  index: number;
  isDragDisabled?: boolean;
};

const withDraggable = <T,>(Component: ComponentType<T>) => {
  // eslint-disable-next-line react/function-component-definition, react/display-name
  return (props: WithDraggableProps<Omit<T, "dragHandleProps" | "handleIcon">>) => {
    const { draggableId, index, isDragDisabled = false, ...rest } = props;

    return (
      <Draggable
        draggableId={draggableId}
        index={index}
        isDragDisabled={isDragDisabled}>
        {(provided) => (
          <Box
            ref={provided.innerRef}
            {...provided.draggableProps}
            style={provided.draggableProps.style}
            sx={{ ":not(:first-of-type)": { marginTop: 1 }, overflow: "unset" }}>
            <Component
              {...(rest as T)}
              index={index}
              dragHandleProps={provided.dragHandleProps}
              handleIconNode={
                <IconButton>
                  <DragHandle />
                </IconButton>
              }
            />
          </Box>
        )}
      </Draggable>
    );
  };
};

export default withDraggable;
